import React from 'react';
import {
  Box,
  Typography,
  Stack,
  useTheme,
  useMediaQuery,
  Dialog,
  Paper,
  Button,
  Link,
} from '@mui/material';
import './verification.scss';
import { ReactComponent as ZicassoSVG } from '../../assets/svg/zicasso-logo-redesign.svg';

export interface ThankYouProps {
  onClickThankYou: () => void;
}

const ThankYouView = ({
  onClickThankYou,
}: ThankYouProps): React.ReactElement => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: isDesktop ? 'flex-start' : 'center',
        justifyContent: 'center',
        py: { mobile: 2, md: 4 },
        bgcolor: isDesktop ? '#f5f5f5' : 'transparent',
      }}
    >
      {isDesktop ? (
        <Dialog
          open
          aria-labelledby="verification-modal-title"
          aria-describedby="verification-modal-description"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Paper
            elevation={6}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              maxWidth: '390px',
              maxHeight: '95vh',
              overflowY: 'auto',
              borderRadius: '16px',
              position: 'relative',
              zIndex: theme.zIndex.modal,
            }}
          >
            <Stack spacing={4} alignItems="center">
              <ZicassoSVG aria-label="Zicasso" />
              <Stack spacing={2}>
                <Typography variant="h2" color="text.primary" sx={{ textAlign: 'center' }}>
                  Thank you for submitting your trip request!
                </Typography>
                <Typography color="text.secondary" style={{ marginTop: '10px', textAlign: 'center' }}>
                  Our team is reviewing your trip request to match you with top travel specialists. You will hear from them shortly.
                </Typography>
              </Stack>
              <Button
                onClick={onClickThankYou}
                variant="contained"
                fullWidth
              >
                Continue
              </Button>
              <Typography sx={{ mt: 3, textAlign: 'center' }}>
                Need help?
                {' '}
                <Link component="a" href="/support">Contact Support Center</Link>
              </Typography>
            </Stack>
          </Paper>
        </Dialog>
      ) : (
        <Stack spacing={4} alignItems="center" padding={4}>
          <ZicassoSVG aria-label="Zicasso" />
          <Stack spacing={2}>
            <Typography variant="h2" color="text.primary" sx={{ textAlign: 'center' }}>
              Thank you for submitting your trip request!
            </Typography>
            <Typography color="text.secondary" style={{ marginTop: '10px', textAlign: 'center' }}>
              Our team is reviewing your trip request to match you with top travel specialists. You will hear from them shortly.
            </Typography>
          </Stack>
          <Button
            onClick={onClickThankYou}
            variant="contained"
            fullWidth
          >
            Continue
          </Button>
          <Typography sx={{ mt: 3, textAlign: 'center' }}>
            Need help?
            {' '}
            <Link component="a" href="/support">Contact Support Center</Link>
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default ThankYouView;
